import { render, staticRenderFns } from "./addNoticeViewList.vue?vue&type=template&id=7ca52e22&scoped=true"
import script from "./addNoticeViewList.vue?vue&type=script&lang=js"
export * from "./addNoticeViewList.vue?vue&type=script&lang=js"
import style0 from "./addNoticeViewList.vue?vue&type=style&index=0&id=7ca52e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca52e22",
  null
  
)

export default component.exports